<p-toast></p-toast>
<div>
    <!-- visible on small screen start -->
    <div class="block md:hidden">
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                    <!-- <mat-icon>menu</mat-icon> -->
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- visible on small screen end -->

    <div class="col-12">
        <div class="card">
            <h5 class=" "> {{'ADD_INVENTORY_DETAILS'| translate}}</h5>
            <div class="card inventoryDetails">
                <form [formGroup]="submitInventoryForm">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-4">
                            <label>{{'PROGRAM_NAME'| translate}}
                            </label>
                            <p-dropdown [options]="pogramNameList" formControlName="programId"
                                placeholder="{{'SELECT_PROGRAM_NAME'| translate}}" optionLabel="Program_Name"
                                optionValue="Program_Id" (onChange)="getChangeProgram($event)"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.programId.errors}">
                            </p-dropdown>
                            <div *ngIf="isSubmitted && f.programId.errors" class="invalid-feedback">
                                <div *ngIf="f.programId.errors.required">{{'PROGRAM_NAME_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label>{{'INVENTORY_CATEGORY'| translate}}
                            </label>
                            <p-dropdown [options]="categoryList" formControlName="categoryId"
                                placeholder="{{'SELECT_CATEGORY'| translate}}" optionLabel="categoryName"
                                optionValue="categoryId" (onChange)="getCategoryChange($event)"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.categoryId.errors}">
                            </p-dropdown>
                            <div *ngIf="isSubmitted && f.categoryId.errors" class="invalid-feedback">
                                <div *ngIf="f.categoryId.errors.required">{{'CATEGORY_IS_REQUIRED'| translate}}</div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label style="margin-right:4px;">{{'COMPONENT'| translate }}</label>
                            <p-dropdown [options]="componentList" formControlName="componentId"
                                placeholder="{{'SELECT_COMPONENT'| translate}}" optionLabel="componentName"
                                optionValue="componentId" (onChange)="getComponentChange($event)"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.componentId.errors}">
                            </p-dropdown>
                            <div *ngIf="isSubmitted && f.componentId.errors" class="invalid-feedback">
                                <div *ngIf="f.componentId.errors.required">{{'COMPONENT_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label style="margin-right:4px;">{{'SIZE'| translate }}</label>
                            <p-dropdown [options]="sizeIdList" formControlName="sizeId"
                                placeholder="{{'SELECT_SIZE'| translate}}" optionLabel="sizeAndPrice"
                                optionValue="sizeId" (onChange)="getSizeIdChange($event)"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.sizeId.errors}">
                            </p-dropdown>
                            <div *ngIf="isSubmitted && f.sizeId.errors" class="invalid-feedback">
                                <div *ngIf="f.sizeId.errors.required">{{'SIZE_IS_REQUIRED'| translate}}</div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label>{{'QUANTITY'| translate}}</label>
                            <input pInputText pKeyFilter="int" id="qauntity" type="text" formControlName="qauntity"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.qauntity.errors}"
                                placeholder="{{'QUANTITY' | translate}}" />
                            <div *ngIf="isSubmitted && f.qauntity.errors" class="invalid-feedback">
                                <div *ngIf="f.qauntity.errors.required">{{'QUANTITY_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label>{{'CONSUMED_QUANTITY'| translate}}</label>
                            <input pInputText pKeyFilter="int" id="consumedQuantity" type="text"
                                formControlName="consumedQuantity"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.consumedQuantity.errors}"
                                placeholder="{{'CONSUMED_QUANTITY' | translate}}" />
                            <div *ngIf="isSubmitted && f.consumedQuantity.errors" class="invalid-feedback">
                                <div *ngIf="f.consumedQuantity.errors.required">{{'CONSUMED_QUANTITY_IS_REQUIRED'|
                                    translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label>{{'BATCH_NO'| translate}}</label>
                            <input pInputText id="batchNo" type="text" formControlName="batchNo"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.batchNo.errors}"
                                placeholder="{{'BATCH_NO' | translate}}" />
                            <div *ngIf="isSubmitted && f.batchNo.errors" class="invalid-feedback">
                                <div *ngIf="f.batchNo.errors.required">{{'BATCH_NO_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label>{{'LOT_NO'| translate}}</label>
                            <input pInputText id="lotNo" type="text" formControlName="lotNo"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.lotNo.errors}"
                                placeholder="{{'LOT_NO' | translate}}" />
                            <div *ngIf="isSubmitted && f.lotNo.errors" class="invalid-feedback">
                                <div *ngIf="f.lotNo.errors.required">{{'LOT_NO_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label for="datePurchase">{{'DATE_OF_INVENTORY'| translate}}</label>
                            <p-calendar [(ngModel)]="datePurchase" [showButtonBar]="true" dateFormat="dd-mm-yy"
                                [showIcon]="true" inputId="datePurchase" formControlName="datePurchase"
                                [maxDate]="currentDate" [minDate]="minDate"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.datePurchase.errors }"></p-calendar>

                            <div *ngIf="isSubmitted && f.datePurchase.errors" class="invalid-feedback">
                                <div *ngIf="f.datePurchase.errors.required">{{'DATE_PURCHASE_IS_REQUIRED'|
                                    translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label>{{'INVOICE_NO'| translate}}</label>
                            <input pInputText id="purchaseInvoiceNo" type="text" formControlName="purchaseInvoiceNo"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.purchaseInvoiceNo.errors}"
                                placeholder="{{'INVOICE_NO' | translate}}" />
                            <div *ngIf="isSubmitted && f.purchaseInvoiceNo.errors" class="invalid-feedback">
                                <div *ngIf="f.purchaseInvoiceNo.errors.required">{{'INVOICE_NO_IS_REQUIRED'|
                                    translate}}
                                </div>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label>{{'ITEM_TYPE'| translate}}</label>
                            <p-dropdown [options]="itemTypeList" formControlName="itemType"
                                placeholder="{{'SELECT_ITEM_TYPE'| translate}}" [(ngModel)]="selectedItemType"
                                optionLabel="item" optionValue="item" (onChange)="getItemTypeChange($event)">
                            </p-dropdown>
                            <div *ngIf="isSubmitted && f.itemType.errors" class="invalid-feedback">
                                <div *ngIf="f.itemType.errors.required">{{'ITEM_TYPE_IS_REQUIRED'| translate}}</div>
                            </div>
                        </div>
                        <div style="display: contents;" *ngIf="!hideData">
                            <div class="field col-12 md:col-3">
                                <label>{{'UPLOAD_BILL_COPY'| translate}}</label>
                                <div class="flex">
                                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #uploadElement
                                        (uploadHandler)="onUpload($event,'billCopyPath', uploadElement)" name="myfile[]"
                                        mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}"
                                        [auto]="true">
                                    </p-fileUpload>
                                    <p-image *ngIf="f.billCopyPath.value && fileType == 'IMAGE'"
                                        [src]="f.billCopyPath.value" alt="Image" width="60"
                                        class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                                    <div *ngIf="f.billCopyPath.value && fileType == 'PDF'" class="flex"
                                        style="margin-top:8px;margin-left: 10px;">
                                        <a style="cursor: pointer;" [href]="f.billCopyPath.value"
                                            target="_blank">{{'VIEW_DOC'| translate}}</a>
                                    </div>
                                </div>
                                <div *ngIf="isSubmitted && f.billCopyPath.errors" class="invalid-feedback">
                                    <div *ngIf="f.billCopyPath.errors.required">
                                        {{'BILL_COPY_IS_REQUIRED'| translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <button pButton pRipple type="button" label="{{'SAVE'| translate}}" class="p-button-success m-2"
                    (click)="submitInventoryDetails()"></button>
            </div>
        </div>
    </div>


    <div class="col-12 mi-inventory-container">

        <!-- visible on small screen start -->
        <div class="block md:hidden">
            <div class="card p-2 mobile-gird-content">
                <div style="padding: 0 1em;">
                    <p class="my-2">{{'INVENTORY_DETAILS'| translate}}</p>
                    <div class="mobile-view-header">
                        <div class="mobile_search">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="mobileSearch($any($event.target).value)"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </div>
                    <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of mobileMiInventoryData">
                        <!-- <table cellspacing="1"> -->
                        <table cellspacing="10">
                            <tr>
                                <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                                <td>
                                    {{item.ProgramName}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'CATEGORY_NAME'| translate}}</b></td>
                                <td>
                                    {{item.CategoryName}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'COMPONENT_NAME'| translate}}</b></td>
                                <td>
                                    {{item.ComponentName}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'SIZE_NAME'| translate}}</b></td>
                                <td>
                                    {{item.SizeName}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'QUANTITY'| translate}}</b></td>
                                <td>
                                    {{item.Quantity}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'PREVIOUS_CONSUMED_QUANTITY'| translate}}</b></td>
                                <td>
                                    {{item.ConsumedQuantity}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'REMAINING_QUANTITY'| translate}}</b></td>
                                <td>
                                    {{item.RemaningQuantity}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'BATCH_NO'| translate}}</b></td>
                                <td>
                                    {{item.BatchNO}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'LOT_NO'| translate}}</b></td>
                                <td>
                                    {{item.LotNo}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'ITEM_TYPE'| translate}}</b></td>
                                <td>
                                    {{item.ItemType}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'INVOICE_NO'| translate}}</b></td>
                                <td>
                                    {{item.PurchaseInvoiceNo}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'INVOICE_BILL_DATE'| translate}}</b></td>
                                <td>
                                    {{item.InvoiceBillDate | date}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{'INVENTORY_ACTION'| translate}}</b></td>
                                <td>
                                    <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                        (click)="updateInventory(item)" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-text"></button>
                                    <button pButton pRipple type="button" pTooltip="Delete-Estimation"
                                        icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
                                        (click)="deleteInventory(item)"></button>
                                </td>
                            </tr>
                        </table>
                    </p-card>
                </div>
            </div>
        </div>
        <!-- visible on small screen end -->

        <!-- visible on large screen start  -->
        <div class="grid hidden md:block">
            <div class="col-12">
                <div class="card">
                    <div class="card dashboardTable">
                        <p-table #miInventoryTable [value]="miInventoryData" [rows]="10" [paginator]="true"
                            [globalFilterFields]="[
                    'ProgramName', 
                    'CategoryName', 
                    'ComponentName', 
                    'SizeName', 
                    'Quantity',
                    'ConsumedQuantity', 
                    'BatchNO', 
                    'LotNo', 
                    'ItemType', 
                    'PurchaseInvoiceNo',
                    'InvoiceBillDate',
                    'RemaningQuantity' ]" responsiveLayout="scroll" [rowHover]="true" dataKey="id"
                            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                            [showCurrentPageReport]="true" sortField="invoiceBillDateForSorting" [sortOrder]="1">
                            <ng-template pTemplate="caption">
                                <div class="flex align-items-center justify-content-between">
                                    <h5 class="m-0">{{'INVENTORY_DETAILS'| translate}}</h5>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input style="width: 100% ;" pInputText type="text"
                                            (input)="miInventoryTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header" class="tableHeader">
                                <tr>
                                    <th pSortableColumn="ProgramName">{{'PROGRAMME_NAME'| translate}}
                                        <p-columnFilter type="text" field="ProgramName" display="menu"></p-columnFilter>
                                        <p-sortIcon field="ProgramName"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="CategoryName">{{'CATEGORY_NAME'| translate}}
                                        <p-columnFilter type="text" field="CategoryName"
                                            display="menu"></p-columnFilter>
                                        <p-sortIcon field="CategoryName"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="ComponentName">{{'COMPONENT_NAME'| translate}}
                                        <p-columnFilter type="text" field="ComponentName"
                                            display="menu"></p-columnFilter>
                                        <p-sortIcon field="ComponentName"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="SizeName">{{'SIZE_NAME'| translate}}
                                        <p-columnFilter type="text" field="SizeName" display="menu"></p-columnFilter>
                                        <p-sortIcon field="SizeName"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="Quantity">{{'QUANTITY'| translate}}
                                        <p-columnFilter type="text" field="Quantity" display="menu"></p-columnFilter>
                                        <p-sortIcon field="Quantity"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="ConsumedQuantity">{{'PREVIOUS_CONSUMED_QUANTITY'| translate}}
                                        <p-columnFilter type="text" field="ConsumedQuantity"
                                            display="menu"></p-columnFilter>
                                        <p-sortIcon field="ConsumedQuantity"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="RemaningQuantity">{{'REMAINING_QUANTITY'| translate}}
                                        <p-columnFilter type="text" field="RemaningQuantity"
                                            display="menu"></p-columnFilter>
                                        <p-sortIcon field="RemaningQuantity"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="BatchNO">{{'BATCH_NO'| translate}}
                                        <p-columnFilter type="text" field="BatchNO" display="menu"></p-columnFilter>
                                        <p-sortIcon field="BatchNO"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="LotNo">{{'LOT_NO'| translate}}
                                        <p-columnFilter type="text" field="LotNo" display="menu"></p-columnFilter>
                                        <p-sortIcon field="LotNo"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="ItemType">{{'ITEM_TYPE'| translate}}
                                        <p-columnFilter type="text" field="ItemType" display="menu"></p-columnFilter>
                                        <p-sortIcon field="ItemType"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="PurchaseInvoiceNo">{{'INVOICE_NO'| translate}}
                                        <p-columnFilter type="text" field="PurchaseInvoiceNo"
                                            display="menu"></p-columnFilter>
                                        <p-sortIcon field="PurchaseInvoiceNo"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="InvoiceBillDate">{{'INVOICE_BILL_DATE'| translate}}
                                        <p-columnFilter type="text" field="InvoiceBillDate"
                                            display="menu"></p-columnFilter>
                                        <p-sortIcon field="invoiceBillDateForSorting"></p-sortIcon>
                                    </th>

                                    <th pSortableColumn="">{{'INVETORY_ACTION'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td>{{product.ProgramName}}</td>
                                    <td>{{product.CategoryName}}</td>
                                    <td>{{product.ComponentName}}</td>
                                    <td>{{product.SizeName}}</td>
                                    <td>{{product.Quantity}}</td>
                                    <td>{{product.ConsumedQuantity}}</td>
                                    <td>{{product.RemaningQuantity}}</td>
                                    <td>{{product.BatchNO}}</td>
                                    <td>{{product.LotNo}}</td>
                                    <td>{{product.ItemType}}</td>
                                    <td>{{product.PurchaseInvoiceNo}}</td>
                                    <td>{{product.InvoiceBillDate | date }}</td>
                                    <td>
                                        <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                            (click)="updateInventory(product)" icon="pi pi-pencil"
                                            class="p-button-rounded p-button-text"></button>
                                        <button pButton pRipple type="button" pTooltip="Delete-Estimation"
                                            icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
                                            (click)="deleteInventory(product)"></button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- visible on large screen end -->
    </div>

</div>


<p-dialog header="{{'UPDATE_INVENTORY_DETAILS'| translate}}" [(visible)]="displayUpdateInventoryDialog" [modal]="true"
    [style]="{ width: '90%', height: '80%' }" [maximizable]="true" [draggable]="false" [resizable]="false" [baseZIndex]="-100"
    (onHide)="onCloseDialog()">
    <div class="card inventoryUpdateDetails">
        <form [formGroup]="submitInventoryForm">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label htmlFor="programId">{{'PROGRAM_NAME'| translate}}</label>
                    <input readonly formControlName="programId" pInputText id="programId" type="text"/>
                    <!-- <label>{{'PROGRAM_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programName
                            }}</label></label> -->

                    <!-- <label>{{'PROGRAM_NAME'| translate}}
                    </label> -->
                    <!-- <p-dropdown [options]="pogramNameList" formControlName="programId"
                        placeholder="{{'SELECT_PROGRAM_NAME'| translate}}" optionLabel="Program_Name"
                        optionValue="Program_Id" (onChange)="getChangeProgram($event)"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.programId.errors}">
                    </p-dropdown>
                    <div *ngIf="isSubmitted && f.programId.errors" class="invalid-feedback">
                        <div *ngIf="f.programId.errors.required">{{'PROGRAM_NAME_IS_REQUIRED'| translate}}
                        </div>
                    </div> -->
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="categoryId">{{'CATEGORY'| translate}}</label>
                    <input readonly formControlName="categoryId" pInputText id="categoryId" type="text"/>



                    <!-- <p-dropdown [options]="categoryList" formControlName="categoryId"
                        placeholder="{{'SELECT_CATEGORY'| translate}}" optionLabel="categoryName"
                        optionValue="categoryId" (onChange)="getCategoryChange($event)"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.categoryId.errors}">
                    </p-dropdown>
                    <div *ngIf="isSubmitted && f.categoryId.errors" class="invalid-feedback">
                        <div *ngIf="f.categoryId.errors.required">{{'CATEGORY_IS_REQUIRED'| translate}}</div>
                    </div> -->
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="componentId">{{'COMPONENT'| translate}}</label>
                    <input readonly formControlName="componentId" pInputText id="componentId" type="text"/>

                    <!-- <label style="margin-right:4px;">{{'COMPONENT'| translate }}</label> -->
                    <!-- <p-dropdown [options]="componentList" formControlName="componentId"
                        placeholder="{{'SELECT_COMPONENT'| translate}}" optionLabel="componentName"
                        optionValue="componentId" (onChange)="getComponentChange($event)"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.componentId.errors}">
                    </p-dropdown>
                    <div *ngIf="isSubmitted && f.componentId.errors" class="invalid-feedback">
                        <div *ngIf="f.componentId.errors.required">{{'COMPONENT_IS_REQUIRED'| translate}}
                        </div>
                    </div> -->
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="sizeId">{{'SIZE'| translate}}</label>
                    <input readonly formControlName="sizeId" pInputText id="sizeId" type="text"/>

                    <!-- <label style="margin-right:4px;">{{'SIZE'| translate }}</label> -->
                    <!-- <p-dropdown [options]="sizeIdList" formControlName="sizeId"
                        placeholder="{{'SELECT_SIZE'| translate}}" optionLabel="sizeAndPrice" optionValue="sizeId"
                        (onChange)="getSizeIdChange($event)"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.sizeId.errors}">
                    </p-dropdown>
                    <div *ngIf="isSubmitted && f.sizeId.errors" class="invalid-feedback">
                        <div *ngIf="f.sizeId.errors.required">{{'SIZE_IS_REQUIRED'| translate}}</div>
                    </div> -->
                </div>
                <div class="field col-12 md:col-4">
                    <label>{{'BATCH_NO'| translate}}</label>
                    <input readonly pInputText id="batchNo" type="text" formControlName="batchNo"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.batchNo.errors}"
                        placeholder="{{'BATCH_NO' | translate}}" />
                    <div *ngIf="isSubmitted && f.batchNo.errors" class="invalid-feedback">
                        <div *ngIf="f.batchNo.errors.required">{{'BATCH_NO_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label>{{'LOT_NO'| translate}}</label>
                    <input readonly pInputText id="lotNo" type="text" formControlName="lotNo"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.lotNo.errors}"
                        placeholder="{{'LOT_NO' | translate}}" />
                    <div *ngIf="isSubmitted && f.lotNo.errors" class="invalid-feedback">
                        <div *ngIf="f.lotNo.errors.required">{{'LOT_NO_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'QUANTITY'| translate}}</label>
                    <input pInputText pKeyFilter="int" id="qauntity" type="text" formControlName="qauntity"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.qauntity.errors}"
                        placeholder="{{'QUANTITY' | translate}}" />
                    <div *ngIf="isSubmitted && f.qauntity.errors" class="invalid-feedback">
                        <div *ngIf="f.qauntity.errors.required">{{'QUANTITY_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'CONSUMED_QUANTITY'| translate}}</label>
                    <input pInputText pKeyFilter="int" id="consumedQuantity" type="text"
                        formControlName="consumedQuantity"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.consumedQuantity.errors}"
                        placeholder="{{'CONSUMED_QUANTITY' | translate}}" />
                    <div *ngIf="isSubmitted && f.consumedQuantity.errors" class="invalid-feedback">
                        <div *ngIf="f.consumedQuantity.errors.required">{{'CONSUMED_QUANTITY_IS_REQUIRED'|
                            translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label for="datePurchase">{{'DATE_OF_INVENTORY'| translate}}</label>
                    <p-calendar appendTo="body" [(ngModel)]="datePurchase" [touchUI]="true" [readonlyInput]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        [showIcon]="true" inputId="datePurchase" formControlName="datePurchase" [maxDate]="currentDate"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.datePurchase.errors }"></p-calendar>

                    <div *ngIf="isSubmitted && f.datePurchase.errors" class="invalid-feedback">
                        <div *ngIf="f.datePurchase.errors.required">{{'DATE_PURCHASE_IS_REQUIRED'|
                            translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'INVOICE_NO'| translate}}</label>
                    <input pInputText id="purchaseInvoiceNo" type="text" formControlName="purchaseInvoiceNo"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.purchaseInvoiceNo.errors}"
                        placeholder="{{'INVOICE_NO' | translate}}" />
                    <div *ngIf="isSubmitted && f.purchaseInvoiceNo.errors" class="invalid-feedback">
                        <div *ngIf="f.purchaseInvoiceNo.errors.required">{{'INVOICE_NO_IS_REQUIRED'|
                            translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'ITEM_TYPE'| translate}}</label>
                    <p-dropdown [options]="itemTypeList" formControlName="itemType"
                        placeholder="{{'SELECT_ITEM_TYPE'| translate}}" [(ngModel)]="selectedItemType"
                        optionLabel="item" optionValue="item" (onChange)="getItemTypeChange($event)">
                    </p-dropdown>
                    <div *ngIf="isSubmitted && f.itemType.errors" class="invalid-feedback">
                        <div *ngIf="f.itemType.errors.required">{{'ITEM_TYPE_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div style="display: contents;" *ngIf="!hideData">
                    <div class="field col-12 md:col-3">
                        <label>{{'UPLOAD_BILL_COPY'| translate}}</label>
                        <div class="flex">
                            <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #uploadElement
                                (uploadHandler)="onUpload($event,'billCopyPath', uploadElement)" name="myfile[]"
                                mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}"
                                [auto]="true">
                            </p-fileUpload>
                            <p-image *ngIf="f.billCopyPath.value && fileType == 'IMAGE'" [src]="f.billCopyPath.value"
                                alt="Image" width="60" class="ml-2 p-button-rounded p-button-success"
                                iconPos="left"></p-image>
                            <div *ngIf="f.billCopyPath.value && fileType == 'PDF'" class="flex"
                                style="margin-top:8px;margin-left: 10px;">
                                <a style="cursor: pointer;" [href]="f.billCopyPath.value" target="_blank">{{'VIEW_DOC'|
                                    translate}}</a>
                            </div>
                        </div>
                        <div *ngIf="isSubmitted && f.billCopyPath.errors" class="invalid-feedback">
                            <div *ngIf="f.billCopyPath.errors.required">
                                {{'BILL_COPY_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <button pButton pRipple type="button" label="{{'UPDATE'| translate}}" class="p-button-success m-2"
            (click)="updateInventoryDetails()"></button>
    </div>


</p-dialog>

<p-confirmDialog [style]="{width: '400px'}" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>